/* eslint-disable react/display-name */
import { ElementType, lazy, Suspense } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(lazy(() => import('../pages/dashboard/GeneralAppPage')));
// DASHBOARD: FILE MANAGER
export const FileManagerPage = Loadable(lazy(() => import('../pages/dashboard/FileManagerPage')));

// TEST RENDER PAGE BY ROLE
export const PermissionDeniedPage = Loadable(
  lazy(() => import('../pages/dashboard/PermissionDeniedPage'))
);

// BLANK PAGE
export const BlankPage = Loadable(lazy(() => import('../pages/dashboard/BlankPage')));

// MAIN
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
export const FaqsPage = Loadable(lazy(() => import('../pages/FaqsPage')));
export const AboutPage = Loadable(lazy(() => import('../pages/AboutPage')));
export const Contact = Loadable(lazy(() => import('../pages/ContactPage')));
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));

// SchoolCenter
export const SchoolCenterList = Loadable(lazy(() => import('../pages/dashboard/SchoolCenterList')));
export const SchoolCenterDetail = Loadable(
  lazy(() => import('../pages/dashboard/SchoolCenterDetail'))
);
// SCHOOLS
export const SchoolList = Loadable(lazy(() => import('../pages/dashboard/SchoolList')));
export const SchoolDetail = Loadable(lazy(() => import('../pages/dashboard/SchoolDetail')));

// STUDENTS
export const StudentList = Loadable(lazy(() => import('../pages/dashboard/StudentList')));
export const StudentDetail = Loadable(lazy(() => import('../pages/dashboard/StudentDetail')));
export const TransportationNeedCheckResultPage = Loadable(
  lazy(() => import('../pages/dashboard/TransportationNeedCheckResultPage'))
);

// TOURLIST
export const TourList = Loadable(lazy(() => import('../pages/dashboard/TourList')));
export const TourDetail = Loadable(lazy(() => import('../pages/dashboard/TourDetail')));
export const TourTransformResultPage = Loadable(
  lazy(() => import('../pages/dashboard/TourTransformResultPage'))
);
export const TourPlanningWizardPage = Loadable(
  lazy(() => import('../pages/TourPlanningWizardPage'))
);

export const MapPage = Loadable(lazy(() => import('../pages/GlobalMapPage')));
// TRANSPORTCOMPANY
export const TransportCompanyList = Loadable(
  lazy(() => import('../pages/dashboard/TransportCompanyList'))
);
export const TransportCompanyDetail = Loadable(
  lazy(() => import('../pages/dashboard/TransportCompanyDetail'))
);
// EMPLOYEES
export const EmployeeList = Loadable(lazy(() => import('../pages/dashboard/EmployeeList')));
export const EmployeeDetail = Loadable(lazy(() => import('../pages/dashboard/EmployeeDetail')));
// VEHICLE
export const VehicleList = Loadable(lazy(() => import('../pages/dashboard/VehicleList')));
export const VehicleDetail = Loadable(lazy(() => import('../pages/dashboard/VehicleDetail')));

// STUDENT APPLICATION FORM
export const StudentApplicationList = Loadable(
  lazy(() => import('../pages/dashboard/StudentApplicationList'))
);
export const StudentApplicationDetail = Loadable(
  lazy(() => import('../pages/dashboard/StudentApplicationDetail'))
);

// BASIC-SETTING
export const SchoolVacationTemplateList = Loadable(
  lazy(() => import('../pages/dashboard/SchoolVacationTemplateList'))
);
export const SchoolVacationTemplateEditForm = Loadable(
  lazy(
    () => import('../sections/@dashboard/school-vacation-template/SchoolVacationTemplateEditForm')
  )
);

export const TransportationPeriodList = Loadable(
  lazy(() => import('../pages/dashboard/TransportationPeriodList'))
);
export const TransportationPeriodEditForm = Loadable(
  lazy(() => import('../sections/@dashboard/transportation-period/TransportationPeriodEditForm'))
);

export const SchoolConfigEdit = Loadable(lazy(() => import('../pages/dashboard/SchoolConfigEdit')));
export const PlaceManagement = Loadable(lazy(() => import('../pages/dashboard/PlaceManagement')));
export const RoadblockManagement = Loadable(
  lazy(() => import('../pages/dashboard/RoadblockManagement'))
);
export const ImportExcelPage = Loadable(lazy(() => import('../pages/dashboard/ImportExcelPage')));

export const GlobalExportPage = Loadable(lazy(() => import('../pages/dashboard/GlobalExportPage')));
export const TourTenderPage = Loadable(lazy(() => import('../pages/dashboard/TourTenderPage')));
export const InterkommunalerLastenausgleichPage = Loadable(
  lazy(() => import('../pages/dashboard/InterkommunalerLastenausgleichPage'))
);
export const TimeMatrixConfig = Loadable(lazy(() => import('../pages/dashboard/TimeMatrixConfig')));

export const EmployeeMessage = Loadable(lazy(() => import('../pages/dashboard/EmployeeMessage')));
export const EmployeeAppExport = Loadable(
  lazy(() => import('../pages/dashboard/EmployeeAppExport'))
);
export const EmployeeAppTrackComparisons = Loadable(
  lazy(() => import('../pages/dashboard/EmployeeAppTrackComparisons'))
);
export const EmployeeMessageDetail = Loadable(
  lazy(() => import('../pages/dashboard/EmployeeMessageDetail'))
);
